import React, { PureComponent } from 'react';
import DashboardPage from '../../../presenters/renewals/dashboard/DashboardPage/DashboardPage';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import * as api from '../../../../services/api';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import moment from 'moment';
import {
  getBranchIds,
  getBranchRouteNumbers
} from '../../../../utils/api-util';
import { connect } from 'react-redux';

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      renewalsRequiringActionCount: 0,
      renewalsAwaitingSignatureCount: 0,
      renewalsPastDueCount: 0,
      formsAwaitingCustomerSignatureCount: 0,
      formsRequiringActionCount: 0,
      customersRequiringAction: null
    };

    this._isMounted = false;
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.appStore.activeBranchId !== prevProps.appStore.activeBranchId
    ) {
      this.updateState();
    }
  }

  updateState() {
    const { activeBranchId, branches, routes } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);
    const allowedRoutes = routes.filter((route) =>
      branchIds.includes(route.branchId)
    );

    const branchRouteNumbers = getBranchRouteNumbers(null, allowedRoutes);

    if (branchIds.length > 0 && branchRouteNumbers.length > 0) {
      Promise.all([
        api.customers.count({
          statuses: [RenewalStatus.APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers,
          mustHaveContract: true
        }),
        api.customers.count({
          statuses: [RenewalStatus.CUSTOMER_APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers,
          mustHaveContract: true
        }),
        api.customers.count({
          contractExpiresBefore: moment().startOf('d').format('Y-MM-DD'),
          branchIds,
          branchRouteNumbers,
          mustHaveContract: true
        }),
        api.customers.search(
          {
            page: {
              size: 5,
              number: 0
            },
            sortBy: {
              name: null,
              direction: null
            }
          },
          {
            statuses: [RenewalStatus.APPROVAL_REQUIRED.name],
            branchIds,
            branchRouteNumbers
          }
        )
      ])
        .then((values) => {
          const [
            renewalRequiringActionCount,
            renewalsSignatureRequiredCount,
            renewalsPastDueCount,
            customersRequiringAction
          ] = values;

          if (this._isMounted) {
            this.setState({
              loading: false,
              renewalsRequiringActionCount: renewalRequiringActionCount.data,
              renewalsAwaitingSignatureCount:
                renewalsSignatureRequiredCount.data,
              renewalsPastDueCount: renewalsPastDueCount.data,
              customersRequiringAction: customersRequiringAction.data.content
            });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <DashboardPage
        renewalsRequiringActionCount={this.state.renewalsRequiringActionCount}
        renewalsAwaitingSignatureCount={
          this.state.renewalsAwaitingSignatureCount
        }
        renewalsPastDueCount={this.state.renewalsPastDueCount}
        customersRequiringAction={this.state.customersRequiringAction}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default connect(mapStateToProps)(Dashboard);
